import { Component, OnInit, Input, Pipe, PipeTransform, ViewChild, QueryList, ViewChildren } from '@angular/core';
import { Ticketview } from '../ticketview/ticketview';
import { Comment } from './comment';
import { CommentService } from './commentService';
import { ActivatedRoute } from '@angular/router';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Sendgridservice } from '../_services/sendgridService';
import { User } from '../user/user';
import { Authenticate } from '../authenticate/authenticate';
import { UserService } from '../_services';
import { environment } from 'src/environments/environment';
import { NC } from './nc';
import { CommandName } from 'protractor';
import { Query } from '@angular/compiler/src/core';
import * as ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { DatePipe } from '@angular/common';
import { ML } from './ML';

@Component({
  selector: 'app-comment',
  templateUrl: './comment.component.html',
  styleUrls: ['./comment.component.less', './ckstyle.css'],
  providers: [DatePipe]
})
export class CommentComponent implements OnInit {
  public cEditor = ClassicEditor;
  public newcom = ClassicEditor;
  public newcommentstring = "";


  @Input() comments: Comment[];
  @Input() ticket: Ticketview;
  newcomment = new Comment;
  @Input() currentUser: User;
  @ViewChildren('thecomments') coms: QueryList<any>;


  auth: Authenticate;
  ml: ML;
  jwt: string;
  uu = environment.appURL;
  constructor(private commentservice: CommentService,
    private http: HttpClient,
    private route: ActivatedRoute,
    private sendgridservice: Sendgridservice,
    private userService: UserService,
    private datePipe: DatePipe) { }

  public commentconfig = {
    toolbar: {
      items: ['bold',
        'italic',
        'link',
        'bulletedList',
        'numberedList',
        'blockQuote',
        'undo',
        'redo']
    }
  };



  endis() {
    this.toggleDisabled();
  }
  public isDisabled = false;
  // ...
  toggleDisabled() {
    this.isDisabled = !this.isDisabled
  }

  ngOnInit() {

    this.getCurrentUser();
    this.toggleDisabled();

    console.log("The in comments are awesome" + this.ticket?.title );
  }


  createComment(): void {

    if (this.newcommentstring != null && this.newcommentstring != "") {
      this.newcomment.ticket = this.ticket.id;
      this.getCurrentUser();
      this.newcomment.user = this.currentUser;
      let nc = new NC;
      nc.user = this.currentUser.id;
      nc.ticket = this.ticket.id;
      nc.content = this.newcommentstring;

      var timestamp = new Date();
      this.datePipe.transform(timestamp, "yyy-MM-dd");
      nc.postedon = timestamp;
      this.newcommentstring = null;
      this.commentservice.createNewComment(nc).subscribe(comment => {
        comment.user = this.currentUser;
        this.comments.unshift(comment);
        this.comments[length].config = { toolbar: { items: [] } };
        var ur = "https://k2ss.fr/ticketing/ticketviews/" + this.ticket.id;
        this.ml = new ML();
        this.ml.content = nc.content.replace(/<[^>]+>/g, '');
        this.ml.subject = this.ticket.title;
        this.ml.sender = this.currentUser.firstname + " " + this.currentUser.lastname;
        this.ml.senton = timestamp;
        this.sendgridservice.sendMail(this.ml).subscribe(any => { });
        this.newcomment.content = null;
      });
    }
    else {
      window.alert("Please make sure you write your comment in the textbox below!");
    }

  }
  deleteComment(comment: Comment, i: number): void {
    this.auth = JSON.parse(sessionStorage.getItem('currentUser'));
    let jwt = this.auth.jwt;
    //console.log("The delete jwt is = " + jwt);
    if (confirm("Are you sure to delete this comment?")) {
      this.commentservice.deleteComment(comment, jwt)
        .subscribe(any => { this.ticket.comments.splice(i, 1); });
    }
  }

  makeEdit(comment: any) {

    //   let  textArea = document.getElementById("ta"+ comment.id) ;
    //textArea.style.removeProperty("display");
    //  this.autogrowById("ta"+ comment.id);
    //  textArea.removeAttribute("disabled");

    //  textArea = document.getElementById("pa"+ comment.id) ;
    //    textArea.style.setProperty("display", "none");


    console.log("Entering MakeEdit");
    comment.config = {
      toolbar: {
        items: ['bold',
          'italic',
          'link',
          'bulletedList',
          'numberedList',
          'blockQuote',
          'undo',
          'redo']
      }
    };
    this.cEditor.reset;
    comment.disabled = !comment.disabled;

    var ckEditor = document.getElementById("pa" + comment.id);
    ckEditor.setAttribute("style", "opacity:1");


  }




  getCurrentUser() {
    try {
      this.auth = JSON.parse(sessionStorage.getItem('currentUser'));
      if (this.auth != null) {

        this.currentUser = this.auth.user;
        //return this.userService.getUserById(this.auth.user.id).subscribe(us=>
        // {
        //  this.currentUser = us;
        //       }) ;
      }
      else
        this.currentUser = null;
      return false;
    }
    catch (e) {
      console.log("we caught an error!!" + e);
      return false;
    }

  }

  updateComment(comment: Comment) {
    console.log("Entering Update Function");
    var commnc = new NC;
    commnc.id = comment.id;
    var ele = document.getElementById("pa" + commnc.id);
    commnc.content = comment.content;
    var ckEditor = document.getElementById("pa" + comment.id);
    ckEditor.setAttribute("style", "opacity:0.7");
    comment.disabled = !comment.disabled;

    this.commentservice.updateComment(commnc).subscribe(response => {
      console.log(this.comments.length);
      this.comments.push(response);
      console.log(this.comments.length);

    });

  }









}
